module.exports = __webpack_public_path__ + "img/7.201a0b19.jpg";